import type { Type } from "ol/geom/Geometry";
import type { Positioning } from "ol/Overlay";

/** OpenLayers 10 compatibility for removed GeometryType enum. */
export const GeometryType = {
  POINT: "Point" as Type,
  LINE_STRING: "LineString" as Type,
  POLYGON: "Polygon" as Type,
  MULTI_POLYGON: "MultiPolygon" as Type,
  CIRCLE: "Circle" as Type,
} as const;

/** OpenLayers 10 compatibility for removed OverlayPositioning enum. */
export const OverlayPositioning = {
  BOTTOM_CENTER: "bottom-center" as Positioning,
  CENTER_CENTER: "center-center" as Positioning,
  CENTER_LEFT: "center-left" as Positioning,
} as const;
